import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { XMarkIcon } from '@heroicons/react/24/outline';

import { MenuButtonOption } from 'components/MenuButton';

type ClearAllFiltersRowProps = {
  onClear: () => void;
};

export const ClearAllFiltersRow: FC<ClearAllFiltersRowProps> = ({ onClear }) => {
  const { t } = useTranslation();

  return (
    <MenuButtonOption
      newGroup
      Icon={XMarkIcon}
      onClick={onClear}
      testId="filters-menu-clear-all"
      analyticsId="filters:menu:clear-all"
    >
      {t('common:components.filters.clearAllFilters')}
    </MenuButtonOption>
  );
};
